import { Group, IconButton, Text, Tooltip } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  zoomButtonTextStyle,
  zoomControlsStyle,
  groupStyle,
} from "../MapboxMapView.css";
import { elevations } from "@huub-web/ui/theme/css/elevations.css";

export type ZoomControlsProps = {
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  className?: string;
};

export const ZoomControls: FC<ZoomControlsProps> = ({
  handleZoomIn,
  handleZoomOut,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={mergeClasses(className, zoomControlsStyle)}>
      <Group className={mergeClasses(elevations.m, groupStyle)}>
        <Tooltip value={t("mapControls.zoomIn")}>
          <IconButton
            size="xs"
            variant="secondary"
            onClick={handleZoomIn}
            title={t("mapControls.zoomIn")}
            aria-label={t("mapControls.zoomIn")}
          >
            <Text variant="bodyL" className={zoomButtonTextStyle}>
              +
            </Text>
          </IconButton>
        </Tooltip>
        <Tooltip value={t("mapControls.zoomOut")}>
          <IconButton
            size="xs"
            variant="secondary"
            onClick={handleZoomOut}
            title={t("mapControls.zoomOut")}
            aria-label={t("mapControls.zoomOut")}
          >
            <Text variant="bodyL" className={zoomButtonTextStyle}>
              -
            </Text>
          </IconButton>
        </Tooltip>
      </Group>
    </div>
  );
};
